import app from 'containers/app'
import TeamsAPI from 'app/api/TeamsAPI'
import TeamsConstants from 'constants/TeamsConstants'
import { captureException } from 'utils/SentryHelpers'

class TeamsActions extends Marty.ActionCreators {
  fetchTeamsForOrg(orgId) {
    this.dispatch(TeamsConstants.FETCH_TEAMS_STARTED)
    return TeamsAPI
      .fetchTeamsForOrg(orgId)
      .then((teams) => this.dispatch(TeamsConstants.FETCH_TEAMS_FINISHED, teams))
      .catch((error) => {
        this.dispatch(TeamsConstants.FETCH_TEAMS_FAILED)
        captureException(error)
      })
  }

  updateTeam(teamId, properties, notification) {
    this.dispatch(TeamsConstants.UPDATE_TEAM_STARTED)
    return TeamsAPI
      .updateTeam(teamId, properties)
      .then((team) => {
        this.dispatch(TeamsConstants.UPDATE_TEAM_FINISHED, teamId, team)

        if (!!notification) {
          app.actions.NotificationActions.pushNotification({ content: notification })
        }
      })
      .catch((error) => {
        captureException(error)
        this.dispatch(TeamsConstants.UPDATE_TEAM_FAILED)
        app.actions.NotificationActions.pushNotification({
          content: error.message,
          variant: 'red',
          sticky: true,
        })
      })
  }
}

export default TeamsActions



// WEBPACK FOOTER //
// ./src/scripts/actions/TeamsActions.js